// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1V84q","disabled":"FileBtn_disabled__3p_1h","warn":"FileBtn_warn__3QOES","fade":"FileBtn_fade__1062Y"};